import * as yup from 'yup';

const schema = yup.object().shape({
  customerId: yup.string().label('customerId').required(),
  palletId: yup.string().label('palletId').required(),
  shippingType: yup.string().label('shippingType').required(),
  containerId: yup
    .string()
    .label('containerId')
    .when('shippingType', {
      is: (val) => val === 'Sea' || val === 'Land',
      then: yup.string().required(),
    }),
  palletMaxWidth: yup.number().label('palletMaxWidth').when('shippingType', {
    is: 'Air',
    then: yup.number().required(),
  }),
  palletMaxHeight: yup.number().label('palletMaxHeight').when('shippingType', {
    is: 'Air',
    then: yup.number().required(),
  }),
  palletMaxLength: yup.number().label('palletMaxLength').when('shippingType', {
    is: 'Air',
    then: yup.number().required(),
  }),
  maxKg: yup.number().label('maxKg'),
});

export default schema;
